import { FilterCheckbox } from 'components/Blocks/Product/Filter/FilterCheckbox/FilterCheckbox';
import {
    filterGroupTitleTwClass,
    filterGroupTwClass,
    getFilterGroupArrowTwClass,
    getFilterGroupContentItemTwClass,
    getFilterGroupContentTwClass,
} from 'components/Blocks/Product/Filter/FilterGroup/FilterGroup';
import { useCurrentFilterQuery } from 'helpers/queryParams/useCurrentFilterQuery';
import { useUpdateFilterQuery } from 'helpers/queryParams/useUpdateFilterQuery';
import { useTypedTranslationFunction } from 'hooks/typescript/UseTypedTranslationFunction';
import { ArrowIcon } from 'public/svg/IconsSvg';
import { useState } from 'react';

type FilterGroupInStockProps = {
    title: string;
    inStockCount: number;
};

const TEST_IDENTIFIER = 'blocks-product-filter-filtergroup-instock';

export const FilterGroupInStock: FC<FilterGroupInStockProps> = ({ title, inStockCount }) => {
    const t = useTypedTranslationFunction();
    const [isGroupOpen, setIsGroupOpen] = useState(true);

    const { updateFilterInStockQuery } = useUpdateFilterQuery();
    const filterQuery = useCurrentFilterQuery();

    return (
        <div className={filterGroupTwClass} data-testid={TEST_IDENTIFIER}>
            <div className={filterGroupTitleTwClass} onClick={() => setIsGroupOpen((prev) => !prev)}>
                {title}
                <ArrowIcon className={getFilterGroupArrowTwClass(isGroupOpen)} />
            </div>
            {isGroupOpen && (
                <div className={getFilterGroupContentTwClass(isGroupOpen)}>
                    <div className={getFilterGroupContentItemTwClass(inStockCount === 0, !filterQuery?.onlyInStock)}>
                        <FilterCheckbox
                            name="onlyInStock"
                            id="onlyInStock"
                            label={t('In stock')}
                            onChange={() => updateFilterInStockQuery(!filterQuery?.onlyInStock)}
                            count={inStockCount}
                            value={!!filterQuery?.onlyInStock}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};
